import { View } from 'react-native'

import { GradientTypography } from '@/src/elements/text/gradient'
import { Typography } from '@/src/elements/text/Typography'
import { useTranslate } from '@/src/lang/useTranslate'

import { PrimaryGradientPrayerSpaceIcon } from './PrimaryGradientPrayerSpaceIcon'

export const StepOne = () => {
  const { t } = useTranslate()

  return (
    <View className="gap-4 mx-6">
      <View className="rounded-full">
        <PrimaryGradientPrayerSpaceIcon />
      </View>
      <GradientTypography size="2xl" black colors="primary">
        {t('prayer-space.onboarding.step-1.title')}
      </GradientTypography>
      <Typography colors="primary" contrast="high" className="mt-6" size="sm">
        {t('prayer-space.onboarding.step-1.description')}
      </Typography>
    </View>
  )
}
